import { useContext } from 'react'
import { SideBarContext } from './provider'
import ListItem from './ListItem'
import useGetMenuContent from './useGetMenuContent'
import { IoMdAddCircleOutline } from "react-icons/io";
import { FaRegArrowAltCircleDown } from "react-icons/fa";
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectCurrentProject } from '@app/features/project/projectSlice'
import Button from '@components/button/Button'
import { IoArrowForward } from 'react-icons/io5'
import TranslatableText from '@components/translations/TranslatableText';
import Skeleton from 'react-loading-skeleton';
import { motion } from 'framer-motion'
import { useIconSize, usePermissions } from '@app/hooks';

const MenuContent = () => {
	const { isSideBarOpen } = useContext(SideBarContext)
	const { project } = useSelector(selectCurrentProject)
	const { enumerableProject, enumerableActivities, isLoading, loadMore } = useGetMenuContent()
	const { isReadOnly } = usePermissions();
	const navigate = useNavigate();
	const arrowForwardIconSize = useIconSize(20);
	const arroAltIconSize = useIconSize(15);
	const addActivitySize = useIconSize(17);
	return (
		<div>
			{
				isSideBarOpen && (
					<div>
						{[enumerableProject, enumerableActivities].map((item, index) => (
							<ListItem key={item.name} item={item} prefix={index + 1} />
						))}

						{
							isLoading && (
								<motion.div
									initial={{ opacity: 0, y: 20 }}
									animate={{ opacity: 1, y: 0 }}
									transition={{ duration: 0.5 }}
								>
									{Array(3).fill(0).map((_, i) => (
										<motion.div
											key={`cart-skeleton-${i}`}
											initial={{ opacity: 0, x: -20 }}
											animate={{ opacity: 1, x: 0 }}
											transition={{ duration: 0.3, delay: i * 0.1 }}
											className="p-1"
										>
											<Skeleton
												height={20}
												borderRadius={8}
												key={`cart-skeleton-${i}`}
												baseColor='var(--primary-dark)'
											/>
										</motion.div>
									))}
								</motion.div>
							)
						}

						<Button onClick={loadMore} className="p-2 mt-1 d-flex align-items-center justify-content-between text-white w-100" style={{ height: 24 }} >
							<div className='d-flex align-items-center'>
								<FaRegArrowAltCircleDown color='white' size={arroAltIconSize} />
								<TranslatableText className='fs-12 px-1' translationKey="main.load_more" />
							</div>
						</Button>
						{!isReadOnly && (
							<Button onClick={() => navigate(`/project/${project?.id}/new-activity`)} className="p-2 mt-1 d-flex align-items-center justify-content-between text-white w-100" style={{ height: 24 }} >
								<div className='d-flex align-items-center'>
									<IoMdAddCircleOutline color='white' size={addActivitySize} />
									<TranslatableText className='fs-12 px-1' translationKey="main.add_activity" />
								</div>
								<IoArrowForward color="white" size={arrowForwardIconSize} />
							</Button>
						)}
					</div>
				)
			}
		</div>
	)
}

export default MenuContent